export default {
  getPurchaseOrder: (state) => state.purchaseOrder,
};
